"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleGranularityJSONModel = exports.defaultLifecycleGranularity = exports.Granularity = void 0;
var Granularity;
(function (Granularity) {
    Granularity["daily"] = "daily";
    Granularity["weekly"] = "weekly";
    Granularity["monthly"] = "monthly";
})(Granularity = exports.Granularity || (exports.Granularity = {}));
exports.defaultLifecycleGranularity = Granularity.daily;
class LifecycleGranularityJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetGranularity();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            this.setGranularity(serializedState);
        };
        this.serialize = () => {
            return this.granularity;
        };
        ////////////////////////////////////////////////
        // Granularity
        ////////////////////////////////////////////////
        this.getGranularity = () => this.granularity;
        this.setGranularity = (value) => this.granularity = validateGranularity(value);
        this.resetGranularity = () => this.setGranularity(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.LifecycleGranularityJSONModel = LifecycleGranularityJSONModel;
const validateGranularity = (value) => {
    if (typeof value === "string" && value in Granularity) {
        return value;
    }
    return exports.defaultLifecycleGranularity;
};
